export function fixedAddButton() {
  const element = document.querySelector('.js-product-fixed-button')
  if (!element) {
    return
  }

  window.addEventListener('scroll', function() {
    if(pageYOffset > 750){
      element.classList.add('fixed')
    }
    if(pageYOffset <= 750){
      element.classList.remove('fixed')
    }
  })
}
